import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';

import PopMembershipContent from './PopMembershipContent';
import PopMembershipTabs from './PopMembershipTabs';

const PopMembership = () => {
  return (
    <section className="pt-20 pb-16" data-cy="pop-membership-section">
      <LayoutGrid rowGap={0}>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <PopMembershipContent />
        </GridItem>
      </LayoutGrid>
      <PopMembershipTabs />
    </section>
  );
};

export default PopMembership;
